/**
 * HMO-Aware Color Getter
 * Provides colors merged with HMO-specific overrides
 * Module-level evaluation ensures single computation (React 19 best practice)
 */

import colors from "assets/theme/base/colors";
import { getHmoColors } from "assets/theme/hmoColors";
import { detectHmo } from "utils/hmoDetection";

/**
 * Merges base colors with HMO-specific overrides
 * @returns Colors object with HMO customizations applied
 */
export function getHmoAwareColors() {
  const detectedHmo = detectHmo(); // Call directly to avoid circular dependency
  const hmoColors = getHmoColors(detectedHmo);
  
  return {
    ...colors,
    primary: {
      ...colors.primary,
      ...(hmoColors.primary || {}),
    },
    secondary: {
      ...colors.secondary,
      ...(hmoColors.secondary || {}),
    },
    gradients: {
      ...colors.gradients,
      ...(hmoColors.gradients || {}),
    },
    coloredShadows: {
      ...colors.coloredShadows,
      ...(hmoColors.coloredShadows || {}),
    },
    scrollbar: {
      ...colors.scrollbar,
      ...(hmoColors.scrollbar || {}),
    },
  };
}

// Cache the merged colors at module level (evaluated once)
// This ensures performance and consistency with React 19 immutable patterns
export const hmoAwareColors = getHmoAwareColors();

